import React, { useEffect, useState } from "react";
import { _get } from "../services/service_api";
import {
  API_BASE_URL,
  directToken,
  Roles_list,
  UPDATE_ROLES,
} from "../services/end_points";
import { Card, ConfigProvider, Switch, Table, Typography } from "antd";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import axios from "axios";

const RolesList = () => {
  const [roles, setRoles] = useState([]);
  const userId = localStorage.getItem("userid");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${Roles_list}${userId}`,
        directToken
      );
      const data = response.data.list;

      const updatedRoles = data.map((role) => ({
        ...role,
        UserManagement: role.userManagement === 1,
        DataManagement: role.dataManagement === 1,
        Appointment: role.appointment === 1,
        Hospital: role.hospital === 1,
        Speciality: role.speciality === 1,
        AssignSpeciality: role.assignSpeciality === 1,
        City: role.city === 1,
        Location: role.location === 1,
        Doctor: role.doctor === 1,
        RoleManegement: role.roleManagement === 1,
        Report: role.Report === 1,
        Edit: role.edit === 1,
        Delete: role.delete === 1,
      }));

      setRoles(updatedRoles);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  };

  const handleOnChange = (checked, name, index) => {
    const updatedRoles = [...roles];
    updatedRoles[index][name] = checked;
    setRoles(updatedRoles);

    const id = updatedRoles[index].id;
    const fieldname = name;
    const value = checked;

    const data = { fieldname, value };

    axios
      .put(`${API_BASE_URL}${UPDATE_ROLES}${id}`, data)
      .then((response) => {})
      .catch((error) => {
        console.error("Error updating role:", error.message);
      });
  };
  const transformedData = [
    {
      label: (
        <Typography style={{ fontWeight: "bold" }}>User Management</Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.UserManagement}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "UserManagement", roles.indexOf(role))
          }
        />
      )),
    },
    {
      // label: 'Data Management',
      label: (
        <Typography style={{ fontWeight: "bold" }}>Data Management</Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.DataManagement}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "DataManagement", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "5",
      // label: 'Hospital',
      label: (
        <Typography style={{ marginLeft: "5%", fontWeight: "bold" }}>
          Hospital
        </Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.Hospital}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "Hospital", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "6",
      // label: 'Speciality',
      label: (
        <Typography style={{ marginLeft: "5%", fontWeight: "bold" }}>
          Speciality
        </Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.Speciality}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "Speciality", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "13",
      // label: 'Speciality',
      label: (
        <Typography style={{ marginLeft: "5%", fontWeight: "bold" }}>
          Assign Speciality
        </Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.AssignSpeciality}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "AssignSpeciality", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "7",
      // label: 'City',
      label: (
        <Typography style={{ marginLeft: "5%", fontWeight: "bold" }}>
          City
        </Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.City}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "City", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "8",
      // label: 'Location',
      label: (
        <Typography style={{ marginLeft: "5%", fontWeight: "bold" }}>
          Area
        </Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.Location}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "Location", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "9",
      // label: 'Doctor',
      label: (
        <Typography style={{ marginLeft: "5%", fontWeight: "bold" }}>
          Doctor
        </Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.Doctor}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "Doctor", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "10",
      // label: 'Appointment',
      label: (
        <Typography style={{ fontWeight: "bold" }}>Appointment</Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.Appointment}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "Appointment", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "11",
      // label: 'Role Management',
      label: (
        <Typography style={{ fontWeight: "bold" }}>Role Management</Typography>
      ),
      values: roles.map((role) => (
        <Switch
          checked={role.RoleManegement}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "RoleManegement", roles.indexOf(role))
          }
        />
      )),
    },
    {
      key: "12",
      // label: 'Report',
      label: <Typography style={{ fontWeight: "bold" }}>Report</Typography>,
      values: roles.map((role) => (
        <Switch
          checked={role.Report}
          size="small"
          onChange={(checked) =>
            handleOnChange(checked, "Report", roles.indexOf(role))
          }
        />
      )),
    },
  ];

  const roleHeaders = ["Admin", "Doctor", "Hospital", "Front Office"];

  const columns = [
    {
      title: "User Type",
      dataIndex: "label",
      key: "label",
    },
    ...roleHeaders.map((role, index) => ({
      title: role, // Custom role header
      dataIndex: "values",
      key: `values_${index}`,
      render: (values) => values[index], // Access the corresponding value in the array
    })),
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Switch: {
            // colorPrimary: "#1236fa",
            colorPrimary: "#6499f1",
          },
        },
      }}
    >
      <DefaultLayout>
        <Card style={{ width: "100%", height: "100%" }}>
          <Table
            columns={columns}
            dataSource={transformedData}
            rowKey="key"
            pagination={{ pageSize: 9 }}
            // scroll={{ x: 1000 }}
            scroll={{ x: "max-content" }}
          />
        </Card>
      </DefaultLayout>
    </ConfigProvider>
  );
};

export default RolesList;
